import {useNavigate} from 'react-router-dom';
import useGetListBrandSummery from '../../../../services/hookService/getListBrandSummery/useGetListBrandSummery';
import BrandItem from './BrandItem';
import BrandItemSkeleton from './BrandItemSkeleton';

const SelectedBrands = () => {
  const navigate = useNavigate();
  const {data, isLoading} = useGetListBrandSummery();

  return (
    <div className="p-3 my-4 bg-farm-shop-400 min-h-44">
      <div className="flex items-center justify-between text-white">
        <div className="flex items-center gap-1">
          <i className="text-2xl icon-nameReceipt-bill-check" />
          <span className="text-md">برند‌های منتخب</span>
        </div>

        <div
          className="flex items-center gap-1"
          onClick={() => navigate('/brands')}
        >
          <span className="text-sm">مشاهده همه</span>
          <i className="text-xl icon-nameArrow---Left-2" />
        </div>
      </div>

      <div className="flex items-start w-full gap-4 pb-8 mt-3 overflow-x-auto whitespace-nowrap scrollbar-hide">
        {isLoading
          ? Array.from({length: 10}, (_, index) => (
              <BrandItemSkeleton key={index} />
            ))
          : data?.map(item => (
              <BrandItem
                key={item?.id}
                data={item}
                onClick={() => navigate(`/brand/${item.id}`)}
              />
            ))}
      </div>
    </div>
  );
};

export default SelectedBrands;
